import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Experience from "./components/Experience/Experience";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { experiences, socialLinks } from "./data/portfolioData";
import { useLanguage } from "./context/LanguageContext";
import { FaWhatsapp } from "react-icons/fa6";
import "./App.css";

function App() {
  const { t } = useLanguage();
  const whatsappUrl = `${socialLinks.whatsapp}?text=${encodeURIComponent(t.contact.whatsappMessage)}`;
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(total > 0 ? (window.scrollY / total) * 100 : 0);
    };
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <div className="App">
      <div className="scroll-progress" style={{ width: `${scrollProgress}%` }} />
      <Navbar />
      <Hero />
      <About />
      <Projects />
      <Experience
        id="experience"
        title={t.sections.experience}
        subtitle={t.sections.experienceSubtitle}
        items={experiences.filter((e) => e.type === "work")}
      />
      <Experience
        id="education"
        title={t.sections.education}
        subtitle={t.sections.educationSubtitle}
        items={experiences.filter((e) => e.type === "education")}
      />
      <Contact />
      <Footer />
      <a
        className="whatsapp-float"
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        aria-label={t.contact.whatsapp}
        title={t.contact.whatsapp}
      >
        <FaWhatsapp aria-hidden="true" />
        <span>{t.contact.whatsapp}</span>
      </a>
    </div>
  );
}

export default App;
